export default "__VITE_ASSET__a6cf390b__"